module.exports = __webpack_public_path__ + "img/logo.a0a7a64f.png";